export const LOGIN_POLICY_UPDATE_BODY_WRAPPER_TEST_ID = "login-policy-update-body-wrapper";
export const LOGIN_POLICY_UPDATE_DRAWER_TEST_ID = "login-policy-update-drawer";

export const LOGIN_POLICY_UPDATE_ACTIVE_SESSIONS_WARNING_STORAGE_KEY =
  "loginPolicyUpdateActiveSessionsWarning";
